/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$('.Slideshow-mobile').slick({
  autoplay:true,
  autoplaySpeed:5000,
  dots: true,
  arrows:false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear'
});

$('.fetured-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows:false,
        dots: true
      }
    },
    {
      breakpoint: 640,
      settings: {
        centerMode: true,
        infinite: true,
        centerPadding: '50px',
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.custom-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows:false,
        dots: true
      }
    },
    {
      breakpoint: 640,
      settings: {
        centerMode: true,
        infinite: true,
        centerPadding: '50px',
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      }
    }
  ]
});


jQuery('.quotes-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows:false,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 5000,
});

// jQuery('.fetured-in-slider').slick({
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   dots: true,
//   arrows:false,
//   responsive: [
//     {
//       breakpoint: 1008,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         dots: false,
//         infinite: true,
//         autoplay: true,
//         autoplaySpeed: 5000
//       }
//     },
//     {
//       breakpoint: 640,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         dots: false,
//         infinite: true,
//         autoplay: true,
//         autoplaySpeed: 5000
//       }
//     }
//   ]
// });

$('.About__Grid .Video__PlayButton').click(function(e){
	e.preventDefault();
  	var modal = $(this).parents('.ImageHero__ContentOverlay').siblings('.Modal');
  	modal.attr('aria-hidden','false');
    modal.attr('tabindex','-1');
    modal.find('iframe').removeClass('.Image--lazyLoad').addClass('Image--lazyLoaded');
});

$('.About__Grid .Modal__Close').click(function(e){
	e.preventDefault();
  	var modal = $(this).parent();
    modal.attr('aria-hidden','true');
    modal.removeAttr('tabindex','-1');
});


$('.pro_main_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite:false,
  asNavFor: '.pro_thumnail',
  adaptiveHeight: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      dots:true
    }
  }]
});

$('.pro_thumnail').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.pro_main_slider',
  focusOnSelect: true,
  vertical: true,
  responsive: [{
    breakpoint: 640,
    settings: {
      vertical: false,

    }
  }]
});

var container = [];

// Loop over gallery items and push it to the array
$('.pro_main_slider').find('img').each(function() {
  var $link = $(this);
  var maxWidth = parseInt($link.data('max-width')),
      maxHeight = parseInt($link.data('max-height')),            
      maxDimension = ($(window).width < 750) ? 1200 : 1800,
      reduceFactor = 1.0;

  if (maxWidth >= maxHeight) {
    reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
  } else {
    reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
  }

  var requestedWidth = Math.floor(maxWidth / reduceFactor);
  var requestedHeight = Math.floor(maxHeight / reduceFactor);


  item = {
    src: $link.attr('src'),
    w: requestedWidth,
    h: requestedHeight,
    title: $link.attr('alt')
  };
  container.push(item);
});


$('.btn-more-info').click(function(e){
    e.preventDefault();	
    $('html, body').animate({
        scrollTop: ($(".Product__Tabs").offset().top - 60 )
    }, 2000);
});


// if($(window).width() > 640){
  $('.Collapsible__Inner').css({'overflow':'visible','height':'auto'});
  $('.Collapsible__Button').attr('aria-expanded','true');
// }